import React from "react";
import { bindActionCreators } from "redux";
import RemindPassword from "../../components/Auth/RemindPassword";
import { connect } from "react-redux";
import { getIsUserLoading, getIsEmailSent, sentRemindPassword, getError } from "../../reducers/user";

const RemindPasswordContainer = props => <RemindPassword {...props} />;

const mapState = (state, props) => ({
  isLoading: getIsUserLoading(state),
  isEmailSent: getIsEmailSent(state),
  error: getError(state)
});

const actions = (dispatch, props) => ({
  sendEmail: bindActionCreators(sentRemindPassword, dispatch),
});

export default connect(mapState, actions)(RemindPasswordContainer);
